import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "./ProfileSetupModal.css";

const RoleSelectionModal = ({ isOpen, onClose, onRoleSelect, userId }) => {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      fetchRoles();
    }
  }, [isOpen]);

  const fetchRoles = async () => {
    try {
      setLoading(true);
      const response = await fetch("https://api.biznetusa.com/api/get-roles");
      const data = await response.json();

      if (data.status === 200 && data.roles) {
        setRoles(data.roles);
      } else {
        toast.error("Failed to fetch roles");
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to load roles. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRoleSelection = (role) => {
    setSelectedRole(role);
  };

  const handleContinue = () => {
    if (!selectedRole) {
      toast.warning("Please select a role to continue");
      return;
    }
    onRoleSelect(selectedRole);
  };

  if (!isOpen) return null;

  return (
    <div className="profile-modal-overlay">
      <div className="profile-modal-container">
        <div className="profile-modal-content">
          {/* Header */}
          <div className="profile-modal-header">
            <h2 className="profile-modal-title">Complete Your Profile</h2>
            <p className="profile-modal-subtitle">
              Select your role to get personalized experience
            </p>
          </div>

          {/* Body */}
          <div className="profile-modal-body">
            {loading ? (
              <div className="profile-modal-loading">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">Loading roles...</p>
              </div>
            ) : (
              <div className="roles-grid">
                {roles.map((role) => (
                  <div
                    key={role.id}
                    className={`role-card ${
                      selectedRole?.id === role.id ? "role-card-active" : ""
                    }`}
                    onClick={() => handleRoleSelection(role)}
                  >
                    <div className="role-card-content">
                      <h3 className="role-card-title">{role.role_name}</h3>
                      {role.permissions && role.permissions.length > 0 && (
                        <p className="role-card-permissions">
                          {role.permissions.length} permission
                          {role.permissions.length > 1 ? "s" : ""}
                        </p>
                      )}
                    </div>
                    {selectedRole?.id === role.id && (
                      <div className="role-card-checkmark">
                        <i className="fas fa-check-circle"></i>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="profile-modal-footer">
            <button
              className="btn btn-primary w-100"
              onClick={handleContinue}
              disabled={!selectedRole || loading}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleSelectionModal;
